<template>
  <Teleport to="body">
    <div
      class="configurator-modal px-0"
      :style="zIndex !== null ? 'z-index: ' + (3001 + zIndex) : ''"
    >
      <div
        class="configurator-modal__overlay"
        @click="emit('close-modal')"
      ></div>
      <div class="container-xl">
        <div class="row mx-auto">
          <div
            class="mx-auto configurator-modal__card"
            :class="props.isPackage ? 'col-12' : 'col-12 col-md-10 col-lg-9'"
          >
            <!-- Close -->
            <div class="configurator-modal__close d-flex w-100">
              <button
                class="btn btn--gray btn--icon-lg btn--rotate btn--icon"
                @click="emit('close-modal')"
              >
                <i class="icon icon-close"></i>
              </button>
            </div>

            <!-- Content -->
            <div
              class="row configurator-modal__content configurator-modal--horizontal gy-5"
            >
              <!-- Image -->
              <div
                class="d-flex align-items-start flex-column"
                :class="
                  props.isPackage
                    ? 'col-11 col-sm-8 col-md-6 pe-md-8'
                    : 'col-11 col-sm-8 col-md-5 pe-md-5'
                "
              >
                <div
                  class="configurator-modal__slider-container w-100 position-relative"
                >
                  <div
                    v-if="showBrievenbusLabel()"
                    class="badge product-card__label"
                  >
                    Brievenbus
                  </div>

                  <div
                    class="configurator-modal__slider position-relative slider"
                    v-if="props.product?.images"
                  >
                    <!-- Product images -->
                    <div
                      class="slide w-100"
                      v-for="image in props.product.images"
                    >
                      <figure class="rimg rimg--contain rimg--100-100 zoom">
                        <img
                          class=""
                          :src="image?.mediumLarge || image"
                          :alt="props.product.name"
                          loading="lazy"
                        />
                      </figure>
                    </div>
                  </div>

                  <button
                    class="btn btn--primary-light btn--icon-sm btn--rotate configurator-modal__slider-button left"
                  >
                    <i class="icon icon-arrow"></i>
                  </button>

                  <button
                    class="btn btn--primary-light btn--icon-sm btn--rotate configurator-modal__slider-button right"
                  >
                    <i class="icon icon-arrow"></i>
                  </button>
                </div>

                <!-- Extra information -->
                <div
                  class="w-100 mt-4"
                  v-if="props.product?.attributes?.length > 0"
                >
                  <span class="h4 d-block mb-2">Extra informatie</span>
                  <div class="table-responsive">
                    <table class="table table-sm fs-sm mb-05">
                      <tbody>
                        <tr
                          v-for="attribute in props.product.attributes"
                          :key="attribute.term_id"
                        >
                          <td class="table__fit-width">
                            {{ decodedAttributeName(attribute.title) }}
                          </td>
                          <td class="fw-medium">
                            <span
                              class="d-flex align-items-center text-capitalize"
                            >
                              {{ attribute.value }}
                              <button
                                v-if="
                                  isPrintingAttribute(attribute) &&
                                  isPrintingValue(attribute)
                                "
                                @click="showPrintingInfoTooltip($event)"
                                class="btn btn--transparent btn--sm printing-info-btn ms-05"
                                style="
                                  text-decoration: none;
                                  vertical-align: baseline;
                                "
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                data-bs-html="true"
                                data-bs-trigger="hover focus"
                                :data-bs-title="
                                  getPrintingTooltipText(attribute)
                                "
                                type="button"
                              >
                                <i
                                  class="icon icon-question-alt text-gray-700"
                                ></i>
                              </button>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!-- Details -->
              <div
                class="justify-content-center d-flex align-items-start flex-column gap-1"
                :class="props.isPackage ? 'col-12 col-md-6' : 'col-12 col-md-7'"
              >
                <!-- Article Number -->
                <span
                  class="d-block fs-xs text-gray-600"
                  v-if="getArticleNumber()"
                >
                  Artikelnummer {{ getArticleNumber() }}
                </span>

                <!-- Title -->
                <span class="h3 text-wrap-balance mb-05 pe-7">{{
                  decodedName(props.product.name)
                }}</span>

                <!-- Product Description (only for products, not packages) -->
                <div
                  v-if="!props.isPackage && props.product.description"
                  class="fs-sm text-gray-600 mb-2"
                  v-html="decodeHtml(props.product.description)"
                ></div>

                <!-- Package list -->
                <div
                  v-if="props.isPackage"
                  class="configurator-modal__products d-flex flex-column w-100"
                >
                  <!-- Producten -->
                  <div
                    class="mb-1"
                    v-if="packageData.basePackage?.products.length > 0"
                  >
                    <span class="fs-sm ps-0">Producten</span>
                    <div
                      class="cart__product cart__product--clickable py-0"
                      v-for="product in packageData.basePackage?.products"
                      :key="product.id"
                      @click="
                        emit('add-modal', {
                          product: product,
                          count: product.count,
                          isPackage: false,
                          isPackaging: false,
                          isPersonalizedCard: false,
                          selected: false,
                          isEditable: false,
                          type: 'products',
                        })
                      "
                    >
                      <div class="cart__product-header">
                        <figure class="img">
                          <img
                            v-if="
                              product.images[0]?.medium &&
                              product.images[0]?.medium !== 'false'
                            "
                            :src="product.images[0]?.medium"
                            :alt="product.name"
                            loading="lazy"
                          />
                        </figure>
                        <div class="d-flex flex-column flex-grow-1">
                          <span class="title">{{
                            decodedName(product.name)
                          }}</span>
                        </div>
                        <div class="cart__product-price">
                          <span class="fs-sm">{{
                            formattedPrice(product.price)
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Eten & drinken -->
                  <div
                    class="mb-1"
                    v-if="packageData.basePackage?.foodDrinks.length > 0"
                  >
                    <span class="fs-sm ps-0">Eten &amp; Drinken</span>
                    <div
                      class="cart__product cart__product--clickable py-0"
                      v-for="product in packageData.basePackage?.foodDrinks"
                      :key="product.id"
                      @click="
                        emit('add-modal', {
                          product: product,
                          count: product.count,
                          isPackage: false,
                          isPackaging: false,
                          isPersonalizedCard: false,
                          selected: false,
                          isEditable: false,
                          type: 'foodDrinks',
                        })
                      "
                    >
                      <div class="cart__product-header">
                        <figure class="img">
                          <img
                            v-if="
                              product.images[0]?.medium &&
                              product.images[0]?.medium !== 'false'
                            "
                            :src="product.images[0]?.medium"
                            :alt="product.name"
                            loading="lazy"
                          />
                        </figure>
                        <div class="d-flex flex-column flex-grow-1">
                          <span class="title">{{
                            decodedName(product.name)
                          }}</span>
                        </div>
                        <div class="cart__product-price">
                          <span class="fs-sm">{{
                            formattedPrice(product.price)
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Verpakking -->
                  <div class="mb-1 mb-sm-0" v-if="packageData.packaging">
                    <span class="fs-sm ps-0">Verpakking</span>
                    <div
                      class="cart__product cart__product--clickable py-0"
                      @click="
                        emit('add-modal', {
                          product: packageData.packaging,
                          count: packageData.packaging.count || 1,
                          isPackage: false,
                          isPackaging: true,
                          isPersonalizedCard: false,
                          selected: false,
                          isEditable: false,
                          type: 'packaging',
                        })
                      "
                    >
                      <div class="cart__product-header">
                        <figure class="img">
                          <img
                            v-if="
                              packageData.packaging?.images?.[0] &&
                              packageData.packaging?.images?.[0] !== 'false'
                            "
                            :src="
                              packageData.packaging?.images?.[0].medium ||
                              packageData.packaging?.image
                            "
                            :alt="packageData.packaging?.name"
                            loading="lazy"
                          />
                        </figure>

                        <div class="d-flex flex-column flex-grow-1">
                          <span class="title">{{
                            decodedName(packageData.packaging?.name)
                          }}</span>
                        </div>
                        <div class="cart__product-price">
                          <span class="fs-sm">{{
                            formattedPrice(packageData.packaging?.price)
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Price -->
                <span class="product-card__price mb-05">
                  <span>{{ formattedPrice(product.price) }}</span> ex. BTW

                  <span
                    v-if="formattedPriceInclVat"
                    class="text-gray-500 fs-sm fw-normal ms-1"
                  >
                    (incl. btw: {{ formattedPriceInclVat }})
                  </span>
                </span>

                <!-- Buttons -->
                <template v-if="props.isEditable">
                  <!-- Packaging -->
                  <template v-if="props.isPackaging">
                    <!-- Packaging -->
                    <button
                      @click.stop="emit('select', product)"
                      class="btn mb-05"
                      :class="{
                        'btn--primary': !props.selected,
                        'btn--secondary': props.selected,
                      }"
                      aria-label="Kies verpakking"
                    >
                      {{ props.selected ? 'Gekozen' : 'Kies deze' }}
                      <i
                        class="icon"
                        :class="props.selected ? 'icon-checkmark' : 'icon-plus'"
                      ></i>
                    </button>
                  </template>

                  <!-- Add / added -->
                  <template
                    v-else-if="
                      props.isPackage ||
                      props.isPersonalizedCard ||
                      props.count === 0
                    "
                  >
                    <!-- Package or personalised card -->
                    <button
                      @click.stop="emit('select', product, props.type)"
                      class="btn mb-05"
                      :class="{
                        'btn--primary': !props.selected,
                        'btn--secondary': props.selected,
                      }"
                      :aria-label="
                        props.isPackage || props.isPersonalizedCard
                          ? 'Kies dit pakket'
                          : 'Voeg product toe'
                      "
                    >
                      {{ getPackageButtonText() }}
                      <i
                        class="icon"
                        :class="props.selected ? 'icon-checkmark' : 'icon-plus'"
                      ></i>
                    </button>
                  </template>

                  <!-- Min Plus -->
                  <template v-else-if="props.count > 0 && !props.isPackage">
                    <!-- Other products with count -->
                    <div class="product-card__actions mb-05 mt-0">
                      <button
                        @click.stop="emit('decrease', props.product)"
                        class="btn btn--icon-lg btn--gray"
                        aria-label="Verlaag aantal"
                      >
                        <i class="icon icon-min"></i>
                      </button>
                      <div class="quantity">{{ props.count }}</div>
                      <button
                        @click.stop="emit('increase', props.product)"
                        class="btn btn--icon-lg btn--primary"
                        aria-label="Verhoog aantal"
                      >
                        <i class="icon icon-plus text-white"></i>
                      </button>
                      <button
                        @click.stop="emit('remove', props.product)"
                        class="remove ms-2"
                        aria-label="Verwijder product"
                      >
                        <i class="icon icon-trashbin ms-0"></i>
                      </button>
                    </div>
                  </template>
                </template>

                <div
                  v-if="
                    volumeDiscountTiers.length > 0 &&
                    !props.isPackage &&
                    !props.isPersonalizedCard &&
                    !props.product.staffelExclude
                  "
                  class="volume-discount-tiers mt-2"
                >
                  <span class="d-block h6 mb-1">Staffelkortingen</span>
                  <div class="volume-discount-tiers__list">
                    <div
                      v-for="tier in volumeDiscountTiers"
                      :key="`${tier.quantity_min}-${tier.quantity_max}`"
                      class="volume-discount-tier mb-025"
                    >
                      <span class="volume-discount-tier__range">
                        {{ formatTierRange(tier) }} pakketten:
                      </span>
                      <span class="volume-discount-tier__discount fw-medium">
                        {{ tier.percentage }}% korting
                      </span>
                    </div>
                  </div>
                </div>

                <div
                  v-if="props.isPersonalizedCard && cardTiers.length > 0"
                  class="volume-discount-tiers mt-2"
                >
                  <span class="d-block h6 mb-1">Kaartprijzen</span>
                  <div class="volume-discount-tiers__list">
                    <div
                      v-for="tier in cardTiers"
                      :key="`${tier.quantity_min}-${tier.quantity_max}`"
                      class="volume-discount-tier mb-025"
                    >
                      <span class="volume-discount-tier__range">
                        {{ formatTierRange(tier) }} kaarten:
                      </span>
                      <span class="volume-discount-tier__discount fw-medium">
                        €{{ formattedPrice(tier.price_per_unit) }} per kaart
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Slot for extra actions -->
                <slot name="extra-actions"></slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, computed, onMounted, watch, nextTick } from 'vue';
import Flickity from 'flickity';
import { Tooltip } from 'bootstrap';
import { initializeProduct } from '../utils/productCountUtils.js';

const props = defineProps({
  product: { type: Object, required: true },
  zIndex: { type: Number, default: 0 },
  count: { type: Number, default: 0 },
  isPackage: { type: Boolean, default: false },
  isPackaging: { type: Boolean, default: false },
  selected: { type: Boolean, default: false },
  isPersonalizedCard: { type: Boolean, default: false },
  isEditable: { type: Boolean, default: true },
  type: { type: String, default: '' },
  packageType: { type: String, default: 'large' },
});

const emit = defineEmits([
  'select',
  'decrease',
  'increase',
  'remove',
  'close-modal',
  'add-modal',
]);

const packageData = ref({
  quantity: 10,
  packageType: 'large',
  isBasePackage: false,
  basePackage: null,
  products: [],
  foodDrinks: [],
  packaging: null,
  packagingOptions: [],
  packagingMode: 'box',
  packagingProduct: null,
  personalMessage: '',
  personalization: {
    productPersonalization: {},
    personalMessage: '',
  },
  deliveryInfo: {},
});

const volumeDiscountTiers = ref([]);
const cardTiers = ref([]);
const printingPrices = ref({});
const printingPricesLoading = ref(false);
const printingTiers = ref({});
const printingTiersLoaded = ref(false);

const printingMethods = [
  { type: 'sticker', label: 'Sticker', attributeName: 'pa_sticker' },
  { type: 'zeefdruk', label: 'Zeefdruk', attributeName: 'pa_zeefdruk' },
  { type: 'graveren', label: 'Graveren', attributeName: 'pa_graveren' },
];

watch(
  () => props.product,
  async (newProduct) => {
    if (!newProduct || props.isPackage) {
      return;
    }

    // Load printing tiers first (needed for prices)
    if (!printingTiersLoaded.value) {
      await loadPrintingTiers();
    }

    // Load prices and re-initialize tooltips
    await loadPrintingPrices();
    await nextTick();
    initializePrintingTooltips();
  },
  { immediate: true },
);

onMounted(() => {
  if (props.isPackage) getPackageData(props.product);

  // Check for escape key and close modal
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') emit('close-modal');
  });

  // Start flickity
  initializeFlickity();
  initZoom();

  // Load volume discount tiers
  loadVolumeDiscountTiers();

  // Load card tiers if personalized card
  if (props.isPersonalizedCard) {
    loadCardTiers();
  }

  // Load printing tiers and prices if applicable
  if (!props.isPackage) {
    loadPrintingTiers().then(() => {
      loadPrintingPrices();
    });
  }

  // Initialize Bootstrap tooltips after DOM is ready
  nextTick(() => {
    initializePrintingTooltips();
  });
});

const showBrievenbusLabel = () => {
  // Alleen tonen bij groot pakket (niet bij brievenbuspakket)
  if (props.packageType === 'small') return false;

  // Check of product geschikt is voor brievenbus
  const attrs = props?.product?.attributes || [];

  const brievenbusAttr = attrs.find((attr) => {
    // Probeer verschillende manieren om het brievenbus attribuut te vinden
    const nameMatch =
      attr.name === 'pa_brievenbus-geschikt' ||
      attr.slug === 'pa_brievenbus-geschikt' ||
      attr.name?.toLowerCase().includes('brievenbus') ||
      attr.slug?.toLowerCase().includes('brievenbus') ||
      attr.name?.toLowerCase().includes('geschikt') ||
      attr.slug?.toLowerCase().includes('geschikt');
    return nameMatch;
  });

  // Product heeft geen brievenbus attribuut
  if (!brievenbusAttr) return false;

  const valueMatch =
    brievenbusAttr.options?.includes?.('ja') || brievenbusAttr.value === 'ja';

  return valueMatch;
};

const formattedPrice = (rawPrice) => {
  if (!rawPrice) return;
  const price = parseFloat(rawPrice.toString());

  return isNaN(price) ? '0,00' : price.toFixed(2).replace('.', ',');
};

const formattedPriceInclVat = computed(() => {
  const rawPrice = props.product?.price_incl_tax;
  if (rawPrice === '' || rawPrice === null || rawPrice === undefined) {
    return '';
  }

  const price = parseFloat(rawPrice);
  return isNaN(price) ? '' : price.toFixed(2).replace('.', ',');
});

const decodedName = (rawName) => {
  if (!rawName) return;
  const name = rawName.toString();

  const txt = document.createElement('textarea');
  txt.innerHTML = name ?? '';
  return txt.value;
};

const decodeHtml = (html) => {
  if (!html) return '';

  return html
    .replace(/\\u003C/g, '<')
    .replace(/\\u003E/g, '>')
    .replace(/\\u003D/g, '=')
    .replace(/\\u0022/g, '"')
    .replace(/\\u0027/g, "'")
    .replace(/\\u0026/g, '&')
    .replace(/(\\r\\n){2,}|(\r\n){2,}|(\\n){2,}|(\n){2,}/g, '<br>')
    .replace(/\\r\\n|\r\n/g, '<br>')
    .replace(/\\n|\n/g, '<br>');
};

const decodedAttributeName = (rawAttributeName) => {
  const txt = document.createElement('textarea');
  txt.innerHTML = rawAttributeName ?? '';
  return txt.value;
};

const getArticleNumber = () => {
  if (props.isPackage) {
    return props.product.sku || props.product.article_number || '';
  } else {
    return props.product.sku || props.product.article_number || '';
  }
};

const getPackageButtonText = () => {
  if (props.isPackage && props.selected) {
    return 'Gekozen';
  }
  if (props.isPackage) {
    return 'Kies deze';
  }
  if (props.isPersonalizedCard && props.selected) {
    return 'Gekozen';
  }
  if (props.isPersonalizedCard) {
    return 'Kies kaart';
  }
  if (props.selected) {
    return 'Gekozen';
  }
  return 'Toevoegen';
};

const initializeFlickity = () => {
  let parent = document.querySelector('.slider');
  let buttonLeft = document.querySelector(
    '.configurator-modal__slider-button.left',
  );
  let buttonRight = document.querySelector(
    '.configurator-modal__slider-button.right',
  );
  if (!parent) return;

  if (parent.querySelectorAll('.slide').length > 1) {
    const flkty = new Flickity(parent, {
      watchCSS: true,
      wrapAround: true,
      pageDots: true,
      prevNextButtons: false,
    });

    buttonLeft.onclick = () => {
      flkty.previous();
    };
    buttonRight.onclick = () => {
      flkty.next();
    };

    flkty.resize();
  }
};

const initZoom = () => {
  $('.zoom').css('display', 'block').parent().zoom();
};

async function loadVolumeDiscountTiers() {
  if (props.isPackage || props.isPackaging || props.isPersonalizedCard) {
    return;
  }

  try {
    // Check if we have cached tiers in sessionStorage
    const cached = sessionStorage.getItem('volumeDiscountTiers');
    const cacheTime = sessionStorage.getItem('volumeDiscountTiersTime');
    const now = Date.now();

    if (cached && cacheTime && now - parseInt(cacheTime) < 300000) {
      volumeDiscountTiers.value = JSON.parse(cached);
      return;
    }

    const response = await fetch('/api/volume-discount/tiers');
    if (response.ok) {
      const data = await response.json();
      volumeDiscountTiers.value = data || [];

      // Cache the result
      sessionStorage.setItem(
        'volumeDiscountTiers',
        JSON.stringify(volumeDiscountTiers.value),
      );
      sessionStorage.setItem('volumeDiscountTiersTime', now.toString());
    }
  } catch (error) {
    console.error('Error loading volume discount tiers:', error);
  }
}

function formatTierRange(tier) {
  const min = tier.quantity_min || 0;
  const max = tier.quantity_max;

  if (!max || max >= 999999) {
    return `${min}+`;
  }

  return `${min}\u2013${max}`;
}

async function loadCardTiers() {
  if (!props.isPersonalizedCard) {
    return;
  }

  try {
    const response = await fetch('/api/cards/tiers');
    if (response.ok) {
      const data = await response.json();
      cardTiers.value = data || [];
    }
  } catch (error) {
    console.error('Error loading card tiers:', error);
  }
}

function isPrintingAttribute(attribute) {
  if (!attribute) return false;

  const attrName = (attribute.name || attribute.slug || '').toLowerCase();
  const printingAttributes = ['sticker', 'zeefdruk', 'graveren'];

  return (
    printingAttributes.some((method) => attrName.includes(method)) ||
    attrName === 'pa_sticker' ||
    attrName === 'pa_zeefdruk' ||
    attrName === 'pa_graveren'
  );
}

function isPrintingValue(attribute) {
  if (!attribute) return false;

  const value =
    attribute.value?.toString().toLowerCase().trim() ||
    attribute.options?.[0]?.toString().toLowerCase().trim() ||
    attribute.option?.toString().toLowerCase().trim() ||
    '';

  const trueValues = ['ja', 'yes', 'true', '1'];
  return trueValues.includes(value);
}

function getPrintingMethodFromAttribute(attribute) {
  if (!attribute) return null;

  const attrName = (attribute.name || attribute.slug || '').toLowerCase();
  const methodMap = {
    sticker: { type: 'sticker', label: 'Sticker' },
    zeefdruk: { type: 'zeefdruk', label: 'Zeefdruk' },
    graveren: { type: 'graveren', label: 'Graveren' },
  };

  for (const [key, method] of Object.entries(methodMap)) {
    if (attrName.includes(key) || attrName === `pa_${key}`) {
      return method;
    }
  }

  return null;
}

async function loadPrintingTiers() {
  if (printingTiersLoaded.value || props.isPackage) {
    return;
  }

  try {
    const response = await fetch('/api/printing/tiers', {
      credentials: 'same-origin',
    });

    if (!response.ok) {
      throw new Error('Failed to load printing tiers');
    }

    printingTiers.value = await response.json();
    printingTiersLoaded.value = true;
  } catch (error) {
    console.error('Error loading printing tiers:', error);
    printingTiers.value = {};
    printingTiersLoaded.value = true; // Prevent retry loops
  }
}

async function loadPrintingPrices() {
  if (
    printingPricesLoading.value ||
    props.isPackage ||
    !props.product?.attributes ||
    !printingTiersLoaded.value
  ) {
    return;
  }

  printingPricesLoading.value = true;
  printingPrices.value = {};

  try {
    const prices = {};

    for (const method of printingMethods) {
      const attr = props.product.attributes.find(
        (a) =>
          a.name === method.attributeName ||
          a.slug === method.attributeName ||
          a.name?.toLowerCase().includes(method.type),
      );

      if (!attr) continue;

      const value =
        attr.value?.toString().toLowerCase().trim() ||
        attr.options?.[0]?.toString().toLowerCase().trim() ||
        '';

      const trueValues = ['ja', 'yes', 'true', '1'];
      if (!trueValues.includes(value)) continue;

      // Get the lowest tier price (minimum quantity tier = vanaf-prijs)
      const tiers = printingTiers.value[method.type];
      if (tiers?.length > 0) {
        const lowestTier = tiers.reduce((lowest, tier) =>
          tier.quantity_min < lowest.quantity_min ? tier : lowest,
        );
        prices[method.type] = lowestTier.price_per_unit;
      }
    }

    printingPrices.value = prices;

    // Re-initialize tooltips after prices are loaded
    await nextTick();
    initializePrintingTooltips();
  } catch (error) {
    console.error('Error loading printing prices:', error);
  } finally {
    printingPricesLoading.value = false;
  }
}

function getPrintingTooltipText(attribute) {
  const method = getPrintingMethodFromAttribute(attribute);
  if (!method) return '';

  const price = printingPrices.value[method.type];

  if (!price) {
    return `${method.label}: Prijzen beschikbaar. Je kunt bedrukking toevoegen in stap 5: Personalisatie.`;
  }

  return `<strong>${method.label}</strong><br>Vanaf €${formattedPrice(price)} per stuk<br>Je kunt bedrukking toevoegen in stap 5: Personalisatie`;
}

function showPrintingInfoTooltip(event) {
  // Bootstrap tooltip will handle this via title attribute
  event.stopPropagation();
}

function initializePrintingTooltips() {
  // Wait for modal animation and DOM to be fully ready
  setTimeout(() => {
    try {
      const modalElement = document.querySelector('.configurator-modal__card');
      if (!modalElement) {
        setTimeout(initializePrintingTooltips, 200);
        return;
      }

      const tooltipElements = modalElement.querySelectorAll(
        'button.printing-info-btn[data-bs-toggle="tooltip"]',
      );

      if (!tooltipElements?.length) {
        return;
      }

      const modalContainer = modalElement.closest('.configurator-modal');

      tooltipElements.forEach((el) => {
        if (!el?.parentElement) return;

        // Dispose existing tooltip if any
        const existingTooltip = Tooltip.getInstance(el);
        if (existingTooltip) {
          existingTooltip.dispose();
        }

        // Find corresponding attribute from table row
        const attributeRow = el.closest('tr');
        if (!attributeRow) return;

        const attributeTitleCell = attributeRow.querySelector('td:first-child');
        if (!attributeTitleCell) return;

        const attributeTitle = attributeTitleCell.textContent.trim();
        const attribute = props.product?.attributes?.find(
          (attr) => decodedAttributeName(attr.title) === attributeTitle,
        );

        if (!attribute) return;

        // Get updated tooltip text with latest prices
        const title = getPrintingTooltipText(attribute);
        if (!title) return;

        // Update tooltip title attribute
        el.setAttribute('data-bs-title', title);

        try {
          // Initialize Bootstrap tooltip
          new Tooltip(el, {
            trigger: 'hover focus',
            html: true,
            placement: 'top',
            container: modalContainer || 'body',
            boundary: 'viewport',
          });
        } catch (error) {
          console.warn('Error initializing tooltip:', error);
        }
      });
    } catch (error) {
      console.warn('Error in initializePrintingTooltips:', error);
    }
  }, 500);
}

async function getPackageData(pakket) {
  // Data already exists, add the data to the existing package, no need to fetch data
  if (pakket.products || pakket.foodDrinks) {
    packageData.value.isBasePackage = true;
    packageData.value.basePackage = {
      ...pakket,
    };

    return;
  }

  // Check if package is valid
  if (!pakket?.id) return;

  try {
    const [pakketRes, allProductsRes] = await Promise.all([
      fetch(`/api/packages/${pakket.id}`),
      fetch('/api/products/products'),
    ]);

    if (!pakketRes.ok) {
      const errorText = await pakketRes.text();
      console.error('Pakket API response:', errorText);
      throw new Error(
        `Pakket API failed: ${pakketRes.status} - ${errorText.substring(0, 100)}`,
      );
    }

    if (!allProductsRes.ok) {
      const errorText = await allProductsRes.text();
      console.error('Products API response:', errorText);
      throw new Error(
        `Products API failed: ${allProductsRes.status} - ${errorText.substring(0, 100)}`,
      );
    }

    const pakketData = await pakketRes.json();
    const allProductsData = await allProductsRes.json();

    // Update the original product object with the new data
    Object.assign(pakket, pakketData);

    packageData.value.isBasePackage = true;
    packageData.value.basePackage = {
      ...pakket,
      ...pakketData, // Include the full package data from API including sku and name
      title: pakketData.title || pakket.title || pakket.name || 'Pakket',
      products: (pakketData.products || []).map((p) => ({
        ...p,
        count: p.count || 1,
        quantity: p.count || 1,
      })),
      foodDrinks: (pakketData.foodDrinks || []).map((f) => ({
        ...f,
        count: f.count || 1,
        quantity: f.count || 1,
      })),
      packaging: pakketData.packaging
        ? {
            id: pakketData.packaging.id,
            name: pakketData.packaging.name,
            title: pakketData.packaging.title || pakketData.packaging.name,
            price: pakketData.packaging.price || 0,
            price_excl_tax:
              pakketData.packaging.price_excl_tax ||
              pakketData.packaging.price ||
              0,
            image: pakketData.packaging.image,
            imageUrl: pakketData.packaging.image,
            attributes: pakketData.packaging.attributes || [],
          }
        : null,
    };

    const pakketProductIds = new Set(
      (pakketData.products || []).map((p) => p.id),
    );
    const pakketProductCounts = {};
    (pakketData.products || []).forEach((p) => {
      pakketProductCounts[p.id] = p.count || 1;
    });

    const allProducts = (allProductsData.items || allProductsData).map((p) => {
      const pakketProduct = pakketData.products?.find(
        (pakP) => pakP.id === p.id,
      );
      const count = pakketProduct ? pakketProduct.count || 1 : 0;

      const product = initializeProduct(p, count);
      return {
        ...product,
        imageUrl: p.imageUrl || p.image || '',
        count: count,
        quantity: count,
      };
    });

    const existingProductIds = new Set(allProducts.map((p) => p.id));
    const missingPakketProducts = (pakketData.products || []).filter(
      (pakketProduct) => !existingProductIds.has(pakketProduct.id),
    );

    const missingProducts = missingPakketProducts.map((p) => {
      const product = initializeProduct(p, p.count || 1);
      return {
        ...product,
        imageUrl: p.imageUrl || p.image || '',
        count: p.count || 1,
        quantity: p.count || 1,
      };
    });

    packageData.value.products = [...allProducts, ...missingProducts];

    packageData.value.foodDrinks = (pakketData.foodDrinks || []).map((f) => {
      const foodDrink = initializeProduct(f, f.count || 1);
      return {
        ...foodDrink,
        imageUrl: f.imageUrl || f.image || '',
        count: f.count || 1,
        quantity: f.count || 1,
      };
    });

    if (pakketData.packaging) {
      packageData.value.packaging = {
        id: pakketData.packaging.id,
        name: pakketData.packaging.name,
        title: pakketData.packaging.title || pakketData.packaging.name,
        price: pakketData.packaging.price || 0,
        image: pakketData.packaging.image,
        imageUrl: pakketData.packaging.image,
        attributes: pakketData.packaging.attributes || [],
      };
    } else {
      packageData.value.packaging = null;
    }
  } catch (error) {
    console.error('Error selecting package:', error);
  } finally {
  }
}
</script>
